module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "printNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Print Settings")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('p', [_vm._v("Print Options coming soon")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f31ec1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/print/nav.vue
// module id = 662
// module chunks = 2